import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import reducers from 'appRedux/reducers';
import { history } from 'util/history';

export const configureStore = (initialState) => {
  const composeEnhancers =
    process.env.REACT_APP_ENV !== 'production'
      ? window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({ trace: true, traceLimit: 25 }) ?? compose
      : compose;

  const middleware = applyMiddleware(thunk, routerMiddleware(history));
  const store = createStore(reducers, initialState, composeEnhancers(middleware));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
};

export const store = configureStore();
